RivalIQ.apps.Alerts.module('views', function (views, App, Backbone, Marionette, $, _, eventDisplay) {

    'use strict';

    function abstractMethod() {
        throw new Error('Not Implemented');
    }

    const Alert = views.Alert = RivalIQ.views.ItemView.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        className: 'alert-list-item',
        initialize: function (options) {
            const me = this;
            const opts = _.extend({}, options);
            _.extend(me, _.pick(opts, 'companyData'));
        },
        templateHelpers: function () {
            return {
                formatter: RivalIQ.formatter.formats
            };
        },
        serializeData: function () {

            const me = this;
            const data = me.model.toJSON();

            me.augmentTemplateData(data);
            data.timezone = me.getProp('timezone');

            return data;
        },
        getAlertIconClassName: abstractMethod,
        getAlertTitle: function () {

            const me = this;
            const data = me.model.toJSON();
            return eventDisplay.getTitle(data.event_type_id, data);
        },
        getAlertDescription: function () {

            const me = this;
            const data = me.model.toJSON();
            return eventDisplay.getDescription(data.event_type_id, data);
        },
        getAlertCategory: function (data) {
            const me = this;
            data = data || me.model.toJSON();
            const eventDisplay = RivalIQ.utils.eventDisplay;
            const eventDetails = eventDisplay.eventDetails[data.event_type_id];
            const category = eventDisplay.eventCategoryDetails[eventDetails.category];
            return (category) ? category.name : '';
        },
        getCompany: function (data) {
            const me = this;

            data = data || me.model.toJSON();

            const company = me.companyData.get(data.company_id);

            return company;
        },
        // TODO this function is waaaay to slow - takes around 25ms to return
        augmentTemplateData: function (data) {
            const me = this;

            const company = me.getCompany(data);

            data.eventTitle = me.getAlertTitle();
            data.eventCategory = me.getAlertCategory(data);
            data.alertIconClassName = me.getAlertIconClassName();
            data.alertDescription = me.getAlertDescription();

            data.companyName = company.get('name');
            data.companyUrl = `/company/${company.id}`;
            data.companyIconUrl = RivalIQ.utils.companyDisplay.getIcon(company.attributes);
            data.companyAbbr = RivalIQ.utils.companyDisplay.getAbbreviation(company.attributes);
        }
    });

    Alert.getViewClassFromType = function (type) {
        let view = Marionette.View;

        const eventDisplay = RivalIQ.utils.eventDisplay;
        if (eventDisplay.hasFacebookAdContent(type)) {
            view = views.FacebookAdsAlert;
        } else if (eventDisplay.hasMetric(type)) {
            view = views.MetricAlert;
        } else if (eventDisplay.hasTextDiff(type)) {
            view = views.TextDiffAlert;
        } else if (eventDisplay.hasUrlDiff(type)) {
            view = views.UrlDiffAlert;
        } else if (eventDisplay.hasPostContent(type) || eventDisplay.hasLikelyBoostedPosts(type)) {
            view = views.PostAlert;
        } else if (eventDisplay.hasMessage(type)) {
            view = views.MessageAlert;
        } else if (eventDisplay.isListeningEvent(type)) {
            view = views.ListeningAlert;
        }

        return view;
    };

    Alert.createFromAlertType = function (type, model) {
        const View = Alert.getViewClassFromType(type);
        return new View({
            model: model
        });
    };

}, RivalIQ.utils.eventDisplay);
